import { Subject, Observer, Observable, Subscriber, Subscription } from 'rxjs'

// rxjs in their wisdom have decided not to expose AnonymousSubject in V6, it is possible
// to import it from 'rxjs/internal/Subject' but that causes a 10k increase in the bundle-size.
// When https://github.com/ReactiveX/rxjs/issues/3869 is resolved it should be imported from 'rxjs'
export class AnonymousSubject<T> extends Subject<T> {
  constructor(protected destination?: Observer<T>, source?: Observable<T>) {
    super()
    this.source = source!
  }

  next(value: T) {
    const { destination } = this
    if (destination && destination.next) {
      destination.next(value)
    }
  }

  error(err: any) {
    const { destination } = this
    if (destination && destination.error) {
      destination.error(err)
    }
  }

  complete() {
    const { destination } = this
    if (destination && destination.complete) {
      destination.complete()
    }
  }

  /** @deprecated This is an internal implementation detail, do not use. */
  _subscribe(subscriber: Subscriber<T>): Subscription {
    const { source } = this
    if (source) {
      return source.subscribe(subscriber)
    } else {
      return Subscription.EMPTY
    }
  }
}
